import { Tag, TagProps } from 'antd';

interface TagInputProps extends TagProps {
  value?: string;
}

const TagInput: React.FC<TagInputProps> = ({ value = '', ...props }) => {
  return <Tag {...props}>{value}</Tag>;
};

export default TagInput;
